import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { ArticlesViewComponent } from '../../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../../base.component';
import { IPopup } from '../../../../../Components/popup/popup.model';
import { BAC_PAGES, DOMAIN_TYPE, SCHEMA_TYPE } from '../../../../../constants';
import { AutoUnsubscribe } from '../../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../../Services/schoolApi.service';
import { IList } from '../../../../../Models/list.model';
import { IResponse } from '../../../../../Models/response.model';
import { ISchoolArticle } from '../../../../../Models/schoolArticle.model';
import { IPageHeader } from '../../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../../Components/pageheader/pageheader.component';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-lycee',
  standalone: true,
  imports: [ArticlesViewComponent, TranslateModule, PageheaderComponent],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-lycee.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacLyceeComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'academics', path: '/academics' },
    children: [
      {
        title: 'stages',
        path: '/academics#STAGES_SECTION',
      },
      {
        title: 'lycee',
        path: null,
      },
    ],
  };
  public preparatoryArticles: IPopup[] = [];
  public start: number = 0;
  public limit: number = 10;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = BAC_PAGES.ACADEMICS.STAGES.LYCEE;
  }

  ngOnInit(): void {
    this.onPaginateEvent(0);
  }

  onPaginateEvent($event: number) {
    this.start = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.preparatoryArticles = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
